<template>
  <div class="authorization-container section-main__warp">
    <!-- 标签 -->
    <div class="type-tab">
      <div
        v-for="item in constData.tabs"
        :key="item.typeId"
        :class="['tab', checkType == item.typeId ? 'active' : '']"
        @click="checkType = item.typeId"
      >
        {{ item.label }}
      </div>
    </div>
    <!-- 内容 -->
    <div class="type-content">
      <div class="content" v-show="checkType == 1">
        <groupAuthorize></groupAuthorize>
      </div>
      <div class="content" v-if="checkType == 2">
        <peopleAuthorize></peopleAuthorize>
      </div>
      <div class="content" v-if="checkType == 3">
        <migrantsPeople></migrantsPeople>
      </div>
    </div>
  </div>
</template>

<script>
import groupAuthorize from "../components/groupAuthorize.vue";
import peopleAuthorize from "../components/peopleAuthorize.vue";
import migrantsPeople from "../components/migrantsPeople.vue";
export default {
  components: {
    groupAuthorize,
    peopleAuthorize,
    migrantsPeople,
  },
  data() {
    return {
      constData: {
        tabs: [
          {
            label: "按权限组授权",
            typeId: "1",
          },
          {
            label: "按人员授权",
            typeId: "2",
          },
          {
            label: "外来人员授权",
            typeId: "3",
          },
        ],
      },
      checkType: "1",
      checkGroup: {
        thirdRightGroupCode: "",
      },
    };
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
:deep .current-row {
  // background: #242b3d !important;
}
:deep .searchForm {
  display: flex;
  justify-content: space-between;
  background: #181f2e;
  align-items: center;
  padding: 11px 16px;
  .el-form-item {
    margin-bottom: 0 !important;
  }
}
.authorization-container {
  width: 100%;
  height: 100%;
  flex-direction: column;
  // @include set_theme_color(background-color, left-menu-bg-color);
  .type-tab {
    height: 42px;
    line-height: 30px;
    padding: 6px 0;
    display: flex;
    @include set_theme_color(background-color, left-menu-bg-color);
    .tab {
      color: #9aa6c1;
      flex: 1;
      text-align: center;
      // padding-bottom: 10px;
      // border-bottom: 2px solid #707070;
      &:hover {
        color: #fff;
        cursor: pointer;
      }
    }
    .active {
      color: #fff;
      // border-color: #407aee;
      background: #407aee;
    }
  }
  .type-content {
    height: 100%;
    margin-top: 16px;
    display: flex;
    justify-content: space-between;
    .content {
      width: calc(100%);
    }
  }
}
</style>